import axios from "axios";

const addMyCard = async (context, obj) => {
    await context.commit('setMyCard', null)
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/billing/v1/card/get/token/`, obj, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access')}`
        }
    })).data
    if (response.success) {
        await context.commit('setMyCard', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const verifyMyCard = async (context, obj) => {
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/billing/v1/card/verify/create/`, obj, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access')}`
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
        await context.dispatch('listMyCard')
        await context.commit('setMyCard', null)
    } else {
        await context.commit('setError', response.code)
    }
};
const listMyCard = async (context) => {
        await context.commit('setMyCardList', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/billing/v1/user/card/list/`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('access')}`
        }
    })).data
    if (response.success) {
        await context.commit('setMyCardList', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const deleteMyCard = async (context, id) => {
    const response = (await axios.delete(`${process.env.VUE_APP_API_URL}/api/billing/v1/user/card/retrieve/${id}/`, {headers: {'Authorization': `Bearer ${localStorage.getItem('access')}`}})).data
    if (response.success) {
        await context.dispatch('listMyCard')
    } else {
        await context.commit('setError', response.code)
    }
};
export default {
    addMyCard,
    listMyCard,
    verifyMyCard,
    deleteMyCard,
}